module.exports = __webpack_public_path__ + "static/amaia-a968c7fc1481b7e226ec33d1ad375e0d.png";